import * as React from 'react';
import { Card, Price } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { usePaymentMethodLabelsMap } from '../../hooks/payments/use-payment-method-labels-map.js';

const PaymentInfo = ({ selectedPaymentMethod , selectedPaymentDetails , totalPrice , summary  })=>{
    const { currency , getLabel  } = useIntl();
    const paymentMethodLabelsMap = usePaymentMethodLabelsMap();
    return /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, getLabel('checkout.completed.paymentDetails.title')), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        className: "checkout-payment-info__value"
    }, getLabel('checkout.payment.method.title')), /*#__PURE__*/ React.createElement(Card.Text, {
        className: "checkout-payment-info__value"
    }, paymentMethodLabelsMap[selectedPaymentMethod.type]), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        className: "checkout-payment-info__value"
    }, getLabel('checkout.completed.paymentDetails.totalValue')), /*#__PURE__*/ React.createElement(Card.Text, {
        className: "checkout-payment-info__value"
    }, totalPrice && totalPrice.centAmount && /*#__PURE__*/ React.createElement(Price, {
        value: totalPrice.centAmount,
        currency: currency
    })), summary && selectedPaymentDetails && /*#__PURE__*/ React.createElement(summary, {
        details: selectedPaymentDetails.data,
        info: selectedPaymentDetails.info,
        result: selectedPaymentDetails.result
    }))));
};

export { PaymentInfo, PaymentInfo as default };
//# sourceMappingURL=PaymentInfo.js.map
